
const OverviewWeighingStation = ()=>{
    return (
        <>
            Đây là tổng quan
        </>
    )
}

export default OverviewWeighingStation
